import DateUtils from "../../../shared/utils/DateUtils";
import MonetaryUtils from "../../../shared/utils/MonetaryUtils";

const normalizeContractsData = contractsData => {
	if (Array.isArray(contractsData?.resultado)) {
		return contractsData.resultado;
	}

	if (Array.isArray(contractsData)) {
		return contractsData;
	}

	return [];
};

export const formatOpenCycle = openCycle => {
	const rawValue = String(openCycle || "");

	if (!rawValue) {
		return {
			openCycle: "",
			openCycleYear: null,
			openCycleValue: "",
			openCycleApiValue: ""
		};
	}

	const [year, ...cycleParts] = rawValue.split("-");
	const hasYear = /^\d{4}$/.test(year);
	const cycleValue = hasYear ? cycleParts.join("-") : rawValue;

	return {
		openCycle: rawValue,
		openCycleYear: hasYear ? Number(year) : null,
		openCycleValue: rawValue,
		openCycleApiValue: cycleValue
	};
};

export const formatContractEquipment = equipment => {
	const invoiceNumber = equipment?.numeroNota || "";
	const equipmentName = equipment?.nomeEquipamento || "";

	return {
		...equipment,
		invoiceNumber,
		equipmentName,
		value: invoiceNumber,
		label: invoiceNumber
			? `${equipmentName} - NF ${invoiceNumber}`
			: equipmentName,
		raw: equipment
	};
};

export const formatContractInstallment = installment => {
	const installmentNumber = installment?.numeroParcela;
	const discountPercentage = installment?.percentualDesconto ?? 0;

	return {
		...installment,
		installmentNumber,
		discountPercentage,
		label: `Parcela ${installmentNumber}`,
		value: MonetaryUtils.formatPercentage(discountPercentage),
		raw: installment
	};
};

export const formatContract = contract => {
	const contractId = contract?.idContrato;
	const purchaseDate = contract?.dataCompra || "";
	const formattedPurchaseDate = DateUtils.formatDateToBrazilian(purchaseDate);
	const openCycle = formatOpenCycle(contract?.cicloAberto);

	const equipmentList = Array.isArray(contract?.equipamentos)
		? contract.equipamentos.map(formatContractEquipment)
		: [];

	const installments = Array.isArray(contract?.parcelas)
		? contract.parcelas.map(formatContractInstallment)
		: [];

	return {
		...contract,
		id: contractId,
		value: String(contractId),
		label: formattedPurchaseDate
			? `Contrato ${contractId} - ${formattedPurchaseDate}`
			: `Contrato ${contractId}`,

		contractId,
		purchaseDate,
		formattedPurchaseDate,

		...openCycle,

		totalValue: contract?.valor ?? 0,
		downPaymentValue: contract?.entrada ?? 0,
		installmentsQuantity: contract?.qtdParcelas ?? "-",
		installments,
		totalDiscount: contract?.totalDesconto ?? 0,
		equipmentList,

		raw: contract
	};
};

export const formatClientContractsResponse = contractsData => {
	return normalizeContractsData(contractsData).map(formatContract);
};